import {
  Component,
  OnInit,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslationService } from './services/translation.service';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  constructor(
    private docTitle: Title,
    private translationService: TranslationService
  ) {}

  ngOnInit(): void {
    // Translations are initialized via APP_INITIALIZER. Just apply current title now.
    this.updateDocTitle();
    this.translationService.onChange(() => this.updateDocTitle());
  }

  private updateDocTitle(): void {
    const appTranslations = this.translationService.getAppTranslations();
    this.docTitle.setTitle(appTranslations?.DOC_TITLE ?? 'hustlen.ai');
  }

}
